export const GET_USER_INCIDENT_PERFORMANCE = 'GET_USER_INCIDENT_PERFORMANCE';
export const GET_USER_INCIDENT_PERFORMANCE_START = `${GET_USER_INCIDENT_PERFORMANCE}_START`;
export const GET_USER_INCIDENT_PERFORMANCE_SUCCESS = `${GET_USER_INCIDENT_PERFORMANCE}_SUCCESS`;
export const GET_USER_INCIDENT_PERFORMANCE_FAIL = `${GET_USER_INCIDENT_PERFORMANCE}_FAIL`;

export function getUserIncidentPerformance(params) {
  // ensure we are not using the workflows/groups params
  const callParams = params;
  if (callParams?.groups) {
    callParams.groups = undefined;
  }
  return {
    type: GET_USER_INCIDENT_PERFORMANCE,
    meta: {
      xmApi: true,
      method: 'get',
      uri: '/webapi/abe/1/performance/users/incidents',
      params: {
        limit: 100,
        offset: 0,
        schedule: true,
        ...callParams,
      },
    },
  };
}
